module.exports = __webpack_public_path__ + "img/info-driver.475dab9b.svg";